import type {
  SsoMembership,
  QuerySsoMembershipsArgs,
} from '@tribeplatform/gql-client/types'

import {
  useQuery,
  type UseQueryOptions,
} from '../../lib/react-query/useQuery.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getSsoMembershipKey } from '../../utils/keys/authToken.keys.js'

export const useSsoMemberships = (options?: {
  variables: QuerySsoMembershipsArgs
  useQueryOptions?: UseQueryOptions<SsoMembership[]>
}) => {
  const { useQueryOptions, variables } = options || {}
  const { client } = useTribeClient()
  const ssoMembershipKey = getSsoMembershipKey({ variables })

  return useQuery<SsoMembership[]>(
    ssoMembershipKey,
    () => client.auth.ssoMemberships(variables),
    useQueryOptions,
  )
}
